import { Interface } from "readline";

import Icon_Default from "./Icon_Default";
import Icon_Arrow_Down from "./Icon_Arrow_Down";
import Icon_Arrow_Up from "./Icon_Arrow_Up";
import Icon_Chart_Column from "./Icon_Chart_Column";
import Icon_Calendar_Fill from "./Icon_Calendar_Fill";
import Icon_Expand_Card from "./Icon_Expand_Card";
import Icon_Calendar from "./Icon_Calendar";
import Icon_File from "./Icon_File";
import Icon_Candidate from "./Icon_Candidate";
import Icon_Expand_All from "./Icon_Expand_All";
import Icon_Collapse_All from "./Icon_Collapse_All";
import Icon_Download_Excel from "./Icon_Download_Excel";
import Icon_Chevron_Left from "./Icon_Chevron_Left";
import Icon_X from "./Icon_X";
import Icon_Heart from "./Icon_Heart";
import Icon_Bookmark from "./Icon_Bookmark";
import Icon_Building from "./Icon_Building";
import Icon_File_Text from "./Icon_File_Text";
import Icon_Bar_Chart from "./Icon_Bar_Chart";
import Icon_User from "./Icon_User";
import Icon_Settings from "./Icon_Settings";
import Icon_Chevron_Down from "./Icon_Chevron_Down";
import Icon_Eye from "./Icon_Eye";
import Icon_Eye_Off from "./Icon_Eye_Off";
import Icon_Check from "./Icon_Check";
import Icon_Hamburger from "./Icon_Hamburger";
import Icon_Filter from "./Icon_Filter";
import Icon_Arrow_Down_Filter from "./Icon_Arrow_Down_Filter";
import Icon_Table_Column_Filter from "./Icon_Table_Column_Filter";
import Icon_Arrow_Wide_Down from "./Icon_Arrow_Wide_Down";
import Icon_Arrow_Wide_Up from "./Icon_Arrow_Wide_Up";
import Icon_Search from "./Icon_Search";
import Icon_Bell from "./Icon_Bell";
import Icon_Home from "./Icon_Home";
import Icon_Profile from "./Icon_Profile";
import Icon_Chevron_Right from "./Icon_Chevron_Right";
import Icon_Search1 from "./Icon_Search1";
import Icon_Clock from "./Icon_Clock";
import Icon_Alert_Triangle from "./Icon_Alert_Triangle";
import Icon_Check_Circle from "./Icon_Check_Circle";
import  Icon_Refresh from "./Icon_Refresh";
import Icon_Users from "./Home_Icons/Icon_Users";
import Icon_Trendingup from "./Home_Icons/Icon_Trendingup";
import Icon_Receipt from "./Home_Icons/Icon_Receipt";
import Icon_Sparkles from "./Home_Icons/Icon_Sparkles";
import Icon_Buildinghp from "./Home_Icons/Icon_Buildinghp";
import Icon_Shield from "./Home_Icons/Icon_Shield";
import Icon_Checkcirclehp from "./Home_Icons/Icon_Checkcirclehp";
import Icon_Cpu from "./Home_Icons/Icon_Cpu";
import Icon_Award from "./Home_Icons/Icon_Award";
import Icon_Dollarsign from "./Home_Icons/Icon_Dollarsign";
import Icon_Trendingupcard from "./Home_Icons/Icon_Trendingupcard";
import Icon_Bookmarkhp from "./Home_Icons/Icon_Bookmarkhp";
import Icon_Options from "./Home_Icons/Icon_Options";
import Icon_Warning from "./Home_Icons/Icon_Warning";
import Icon_Message from "./Home_Icons/Icon_Message";
import Icon_Mic from "./Home_Icons/Icon_Mic";
import Icon_Send from "./Home_Icons/Icon_Send";
import Icon_Link from "./Icon_Link";
import Icon_Headset from "./Icon_Headset";
import Icon_Minimize from "./Icon_Minimize";
interface Icons_Repository_Input{
    iconName : string,
    color?: string

}

function Icons_Repository({iconName , color}:Icons_Repository_Input){

    const returnIcon = () => {
    switch(iconName){
        case 'arrow_down':
            return <Icon_Arrow_Down/>
        case 'arrow_up':
            return <Icon_Arrow_Up/>
        case 'chart_column':
            return <Icon_Chart_Column/>
        case 'calendar_fill':
            return <Icon_Calendar_Fill/>
        case 'expand_card':
            return <Icon_Expand_Card/>
        case 'calendar':
            return <Icon_Calendar/>
        case 'candidate':
            return <Icon_Candidate/>
        case 'file':
            return <Icon_File/>   
         case 'expand_all_icon':
            return <Icon_Expand_All/>
        case 'collapse_all_icon': 
            return <Icon_Collapse_All/>
        case 'download_excel':
            return <Icon_Download_Excel/> 
      case "hamburger":
        return <Icon_Hamburger/>
      case "chevron_left":
        return <Icon_Chevron_Left  />
      case "x":
        return <Icon_X  />
      case "heart":
        return <Icon_Heart  />
      case "bookmark":
        return <Icon_Bookmark  />
      case "building":
        return <Icon_Building  />
      case "file_text":
        return <Icon_File_Text  />
      case "bar_chart":
        return <Icon_Bar_Chart  />
      case "user":
        return <Icon_User />
      case "settings":
        return <Icon_Settings />
      case "chevron_down":
        return <Icon_Chevron_Down/>
      case "eye":
        return <Icon_Eye/>;
      case "eye_off":
        return <Icon_Eye_Off />
      case "check":
        return <Icon_Check  />
      case "filter":
        return <Icon_Filter />
      case "arrow_down_filter":
          return <Icon_Arrow_Down_Filter/>
      case "table_column_filter":
            return <Icon_Table_Column_Filter/>
      case "arrow_wide_down":
              return <Icon_Arrow_Wide_Down/>
      case "arrow_wide_up":
              return <Icon_Arrow_Wide_Up/>
      case "search":
                return <Icon_Search/>
      case "bell":
                return <Icon_Bell/>
      case "profile":
                return <Icon_Profile/>
      case "home":
                return <Icon_Home/>
      case "chevron_right":
        return <Icon_Chevron_Right />
      case "clock":
                return <Icon_Clock />
      case "check_circle":
                return <Icon_Check_Circle />
      case "alert_triangle":
                return <Icon_Alert_Triangle />
      case "search1":
                return <Icon_Search1/>
      case "refresh":
        return <Icon_Refresh/>
      case "link":
        return <Icon_Link/>
      case "users":
        return <Icon_Users/>
      case "trendingup":
        return <Icon_Trendingup/>
      case "receipt":
        return <Icon_Receipt/>
      case "sparkles":
        return <Icon_Sparkles/>
      case "buildinghp":
        return <Icon_Buildinghp/>
      case "shield":
        return <Icon_Shield/>
      case "checkcirclehp":
        return <Icon_Checkcirclehp/>
      case "cpu":
        return <Icon_Cpu />
      case "award":
        return <Icon_Award/>
      case "dollarsign":
        return <Icon_Dollarsign />
      case "trendingupcard":
        return <Icon_Trendingupcard/>
      case "bookmarkhp":
        return <Icon_Bookmarkhp />
      case "options":
        return <Icon_Options />
      case "warning":
        return <Icon_Warning />
      case "message":
        return <Icon_Message/>
      case "mic":
        return <Icon_Mic/>
      case "send":
        return <Icon_Send/>
       case "headset":
        return <Icon_Headset/>
        case "minimize":
        return <Icon_Minimize/>

      default:
            return <Icon_Default/>

    }
};

    return(
       <div style={{height : "100%", width : "100%"}}>{returnIcon()}</div>
    );
}





export default Icons_Repository;